import { Client } from '@/common/services/Client';

interface ChangeBillingStatusRequest {
  status: string;
}

export async function changeBillingStatus(
  billingUuid: string,
  status: string,
): Promise<void> {
  const response = await Client.post<void, ChangeBillingStatusRequest>({
    body: {
      status: status,
    },
    endpoint: `/billing/${billingUuid}/status`,
  });
  return response.data;
}
